import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { DashboardStats } from '../../domain/models/dashboard-stats';
import { Observable } from 'rxjs';
import { PaginatedFiles } from '../../domain/models/file/paginated-files';
import { UserStats } from '../../domain/models/user/user-stats';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private readonly http = inject(HttpClient);
  private baseUrl = environment.apiUrl;

  getUserStatsForPeriod(
    oidcId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<UserStats> {
    const params = new HttpParams()
      .set('oidcId', oidcId)
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    return this.http.get<UserStats>(
      `${this.baseUrl}api/files/user-stats-for-period`,
      { params },
    );
  }

  getStatsForPeriod(
    startDate: Date,
    endDate: Date,
  ): Observable<DashboardStats> {
    const params = new HttpParams()
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    return this.http.get<DashboardStats>(
      `${this.baseUrl}api/files/stats-for-period`,
      { params },
    );
  }

  getConvertedFiles(
    page: number,
    pageSize: number,
    search: string,
    fileType: string,
    sortColumn?: string,
    sortDirection?: 'asc' | 'desc',
    startDate?: Date,
    endDate?: Date,
    companyIds?: string[],
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }
    if (fileType) {
      params = params.set('fileType', fileType);
    }
    if (sortColumn) {
      params = params.set('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.set('sortDirection', sortDirection);
    }
    if (startDate) {
      params = params.set('startDate', startDate.toISOString());
    }
    if (endDate) {
      params = params.set('endDate', endDate.toISOString());
    }
    if (companyIds?.length) {
      companyIds.forEach((id) => {
        params = params.append('companyIds', id);
      });
    }

    return this.http.get<PaginatedFiles>(`${this.baseUrl}api/files/paginated`, {
      params,
    });
  }
}
